<template>
  <div class="drivers">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>

    <div class="col-12 text-left">
      <h1>{{ title }}</h1>
      <h6 class="text-danger" v-if="non_field_errors">{{ non_field_errors }}</h6>
    </div>

    <div class="row" v-if="driver">
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">User ID</label>
        <input type="text" placeholder="User ID" v-model="id_driver"
               class="form-control" disabled/>
        <div v-if="errors" class="text-danger">{{ errors.id_driver }}</div>
      </div>

      <!--<div class="col-md-10 col-lg-10 m-0 p-0"></div>-->

      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Social Security Number</label>
        <input type="text" placeholder="SSN" v-model="driver.ssn"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.ssn }}</div>
      </div>
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Driver License Number</label>
        <input type="text" placeholder="DL Number" v-model="driver.driver_license_number"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.driver_license_number }}</div>
      </div>
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Driver License State</label>
        <input type="text" placeholder="DL State" v-model="driver.driver_license_state"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.driver_license_state }}</div>
      </div>

      <!--<div class="col-md-6 col-lg-6 m-0 p-0"></div>-->

      <div class="col-md-2 col-lg-3 m-0 p-0">
        <label class="search-label">Driver License Expiration Date</label>
        <VueCtkDateTimePicker v-model="driver.driver_license_expires_at" format="YYYY-MM-DD HH:mm:ss" label="Driver License Expiration" />
        <div v-if="errors" class="text-danger">{{ errors.driver_license_expires_at }}</div>
      </div>

      <div class="col-md-2 col-lg-3 m-0 p-0">
        <label class="search-label">Activated At</label>
        <VueCtkDateTimePicker v-model="driver.activated_at" format="YYYY-MM-DD HH:mm:ss" label="Driver Activated At" />
        <div v-if="errors" class="text-danger">{{ errors.activated_at }}</div>
      </div>
    </div>

    <div class="row" v-if="user">
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Username</label>
        <input type="text" placeholder="User ID" v-model="user.username"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.username }}</div>
      </div>

      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">First Name</label>
        <input type="text" placeholder="User ID" v-model="user.name_first"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.name_first }}</div>
      </div>

      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Last Name</label>
        <input type="text" placeholder="SSN" v-model="user.name_last"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.name_last }}</div>
      </div>
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Email</label>
        <input type="text" placeholder="DL Number" v-model="user.email"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.email }}</div>
      </div>
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Phone Number</label>
        <input type="text" placeholder="DL State" v-model="user.phone_number"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.phone_number }}</div>
      </div>
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Gender</label>
        <input type="text" placeholder="DL State" v-model="user.gender"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.gender }}</div>
      </div>

      <div class="col-md-2 col-lg-3 m-0 p-0">
        <label class="search-label">Birthday</label>
        <VueCtkDateTimePicker v-model="user.date_birth" format="YYYY-MM-DD HH:mm:ss" label="Driver's Birthday" />
        <div v-if="errors" class="text-danger">{{ errors.date_birth }}</div>
      </div>

      <div class="col-md-6 col-lg-6 m-0 p-0">
        <label class="search-label">Bio</label>
        <input type="text" placeholder="DL State" v-model="user.bio"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.bio }}</div>
      </div>
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">City</label>
        <input type="text" placeholder="DL State" v-model="user.location_city"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.location_city }}</div>
      </div>
      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Zipcode</label>
        <input type="text" placeholder="DL State" v-model="user.location_zipcode"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.location_zipcode }}</div>
      </div>
      <div class="col-md-6 col-lg-6 m-0 p-0">
        <label class="search-label">Address</label>
        <input type="text" placeholder="DL State" v-model="user.location_address_1"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.location_address_1 }}</div>
      </div>
    </div>

    <div class="submit-button">
      <button v-on:click="updateDriver()" class="btn btn-primary btn-sm" style="width:100%">Update</button>
    </div>

    <div v-if="driver">
      <div class="col-12">
        <div class="col-12">
          <a v-if="user.id_profile_image" href="https://wingz.me/p/43633">
            <img class="rounded-circle" style="height: 100px; width: 100px; object-fit: cover;"
                 :src="user.id_profile_image.url"
                 alt="No profile picture">
          </a>
        </div>
      </div>
      <!--<div class="col-12 text-left">-->
      <!--<span class="font-weight-bold">Market:</span> Los Angeles Area-->
      <!--</div>-->
      <!--<div class="col-12 text-left">-->
      <!--<span class="font-weight-bold">Airports:</span>-->
      <!--BUR-->
      <!--LGB-->
      <!--LAX-->
      <!--</div>-->
      <div class="col-12">
        <span class="font-weight-bold">Location:</span>
        {{ user.location_address_1 }}
      </div>
      <div class="col-12">
        <span class="font-weight-bold">Rides:</span> 930
      </div>
      <!--<div class="col-12">-->
      <!--<span class="font-weight-bold">Rating:</span> 4.9229-->
      <!--</div>-->
      <!--<div class="col-12">-->
      <!--<span class="font-weight-bold">Favorited:</span> 89 times-->
      <!--</div>-->

      <div class="col-12">
        <hr>
      </div>

      <div class="col-12">
        <span class="font-weight-bold">Name:</span>
        {{ user.name_first }} {{ user.name_last }}
      </div>
      <!--<div class="col-12">-->
      <!--<span class="font-weight-bold">Referral:</span> nelson.bae.1-->
      <!--</div>-->
      <div class="col-12">
        <span class="font-weight-bold">Phone:</span>
        <a href="https://countrycode.org/US">[US] {{ user.phone_number }}</a>
      </div>
      <div class="col-12">
        <span class="font-weight-bold">Email:</span>
        {{ user.email }}
      </div>
      <div class="col-12">
        <span class="font-weight-bold">Date of Birth:</span>
        {{ user.date_birth }}
      </div>
      <div class="col-12">
        <span class="font-weight-bold">SSN:</span>
        {{ driver.ssn }}
      </div>
      <div class="col-12 mt-2">
        <span class="font-weight-bold">Driver's License Number:</span>
        {{ driver.driver_license_number }}
      </div>
      <div class="col-12">
        <span class="font-weight-bold">Driver's License State:</span>
        {{ driver.driver_license_state }}
      </div>
      <div class="col-12">
        <span class="font-weight-bold">Driver's License Expiration:</span>
        {{ driver.driver_license_expires_at }}
      </div>


      <div class="col-12">
        <hr>
      </div>

      <div class="col-12">
        <span class="font-weight-bold">Driver activated since:</span>
        {{ driver.activated_at }}
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'UpdateDriver',
    data () {
      return {
        title: 'Update a driver',
        isLoading: false,
        errors: null,
        non_field_errors: null,
        id_driver: 1,
        // ssn: '',
        // driver_license_number: '',
        // driver_license_state: '',
        // driver_license_expires_at: null,
        driver: null,
        user: null
      }
    },
    components: {
      Loading
    },
    methods: {
      getDriver: function () {
        this.reset()
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'drivers-search/?id_user=' + this.id_driver)
          .then(response => {
            console.log(response.data)
            this.user = response.data
            if (this.user.drivers) {
              this.driver = this.user.drivers[0]
            }
            // this.driver = user.drivers[0]
            // this.ssn = this.driver.ssn
            // this.driver_license_number = this.driver.driver_license_number
            // this.driver_license_state = this.driver.driver_license_state
            // this.driver_license_expires_at = this.driver.driver_license_expires_at
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      updateDriver: function () {
        this.reset()
        this.isLoading = true

        // let id_driver = this.driver.id_driver
        delete this.driver.id_driver
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'drivers/' + this.id_driver + '/', this.driver)
          .then(response => {
            Vue.toasted.show('Success!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(response.data)
            this.id_ride = response.data.id_ride
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })

        this.user.id_profile_image = this.user.id_profile_image.id_image
        if (!this.user.is_superuser) {
          this.user.is_superuser = 0
        }
        if (!this.user.is_staff) {
          this.user.is_staff = 0
        }
        this.$http
          .put(process.env.API_BASE_URL_CS + 'users/' + this.id_driver + '/', this.user)
          .then(response => {
            Vue.toasted.show('Success!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(response.data)
            this.id_ride = response.data.id_ride
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      reset: function () {
        this.errors = null
        this.non_field_errors = null
        this.id_ride = null
      }
    },
    mounted () {
      this.id_driver = this.$route.params.id_driver
      this.getDriver()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    /*position: fixed;*/
    /*bottom: 60px;*/
    /*right: 50%;*/
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/UpdateDriver.vue